import { ILearning } from "@kunduz/data-access-learning-api";
import { BreadCrumb } from "@kunduz/ui";
import { getContentUrl, ReservedWords } from "@kunduz/utility-common";

export const LearningBreadcrumb = (props: Props) => {
  function prepareBase() {
    return {
      label: props.homePageLabel,
      url: getContentUrl({
        lang: props.lang,
        contentType: ReservedWords.TR_CONTENT_EXAM,
        segments: ["yks"],
      }),
    };
  }

  function prepareItems(): {
    label: string;
    url?: string;
  }[] {
    const items = props.items.map((item, index) => ({
      label: item.name,
      ...(index !== props.items?.length - 1 && {
        url: `/${props.lang}${item.slug}`,
      }),
    }));

    return items;
  }

  return (
    <BreadCrumb
      base={prepareBase()}
      items={prepareItems()}
      linkAs={props.linkAs}
    />
  );
};

interface Props {
  items: ILearning.BreadcrumbMeta[];
  homePageLabel: string;
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}
